/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_OBL_PAYMENTS_ITEM = {
  id: 'payments_sidebar',
  screenId: 'tax-obl-payments',
  label: 'Ver Pagos',
  description: 'Comprobantes de pago imputados a obligaciones impositivas.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás los pagos ya registrados contra obligaciones impositivas: impuesto, período, monto y comprobante. Al tocar una fila ves el recibo de pago completo.',
      },
      {
        title: 'Filtros',
        fields: [
          { label: 'Año', description: 'Por defecto el año en curso.' },
          { label: 'Mes', description: 'Opcional. «Todos» muestra cualquier mes del año.' },
          { label: 'Impuesto', description: 'Opcional. Filtra por un impuesto del catálogo.' },
        ],
      },
      {
        title: 'Grilla',
        bullets: [
          'Columnas: Fecha pago, Impuesto, Período, Monto pagado, Comprobante.',
          'Tocá una fila para abrir el comprobante de pago asociado.',
        ],
      },
    ],
  },
}
